import React from 'react';
import TableComponent from '../../components/TableComponent';
import Routes from '../../constants/routes';
import { ServicesShoppingService } from '../../service';
import Utils from '../../Utils';
const tableHead = [
  {
    id: 'name',
    label: 'Nome',
  },
];
class ServiceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
    };
    this.getPage();
  }

  async getPage() {
    try {
      const res = await ServicesShoppingService.list('services');
      this.setState({ data: res.data, loading: false });
    } catch (e) {
      console.log(e);
    }
  }

  onCreateClick = () => {
    this.props.history.push(Routes.newService);
  };

  onEditClick = id => {
    this.props.history.push(Routes.editService.replace(':id', id));
  };

  onDeleteClick = item => {
    Utils.alertRemove(ServicesShoppingService, this.state.data, item).then(data => {
      this.setState({ data });
    });
  };

  render() {
    return (
      <TableComponent
        loading={this.state.loading}
        tableTitle="Serviços"
        tableHead={tableHead}
        addText="Novo"
        data={this.state.data}
        onCreateClick={this.onCreateClick}
        onEditClick={this.onEditClick}
        onDeleteClick={this.onDeleteClick}
      />
    );
  }
}

export { ServiceList };
